import { EnvironmentActivityChartCard } from '../../EnvironmentActivityChartCard';
import { useDemoPageProps } from '../DemoPageContext';
import { DemoPageTabLayout } from '../DemoPageTabLayout';
import { SessionsBreakdownCard } from './SessionsBreakdownCard';

export const ActivitiesTab = () => {
  const { organizationId, demoId, workspaceId } = useDemoPageProps();

  return (
    <DemoPageTabLayout>
      <div className="flex flex-col gap-6">
        <EnvironmentActivityChartCard
          organizationId={organizationId}
          workspaceIds={[workspaceId]}
          demoId={demoId}
          timePeriodFilter
          location="demo_info_page"
          resourceTypes={['managed_presentation', 'shared_presentation']}
        />
        <div className="pb-10">
          <SessionsBreakdownCard />
        </div>
      </div>
    </DemoPageTabLayout>
  );
};
